import { useCallback, useState } from 'react';
import styles from './lockModal.module.scss';
import Modal from 'src/components/modal/Modal';
import Button from 'src/components/button/Button';
import SafetyIcon from '@src/assets/icons/safety.svg?react';
import { StudyPlan, useHeaLockAccountMutation } from '@src/api/graphql-codegen';
import Spinner from '@src/components/spinner/Spinner';


type Props = {
  open: boolean;
  studyPlan?: StudyPlan;
  onClose: () => void;
  onContinue: () => void;
};

function LockModal(props: Props) {
  const { open, studyPlan, onClose, onContinue } = props;

  const [beError, setBeError] = useState('')

  const [heaLockAccount, { loading }] = useHeaLockAccountMutation({
    onCompleted: () => {
      onContinue();
    },
    onError: (e) => {
      setBeError(e.message);
    }
  });

  const handleContinue = useCallback(async () => {
    if (studyPlan?.id) {
      await heaLockAccount({
        variables: {
          input: { id: studyPlan.id }
        }
      })
    }
    onClose();
  }, [heaLockAccount, onClose, studyPlan?.id]);

  const handleCancel = () => {
    onClose();
  }

  return (
    <Modal global={false} open={open} onClose={onClose} closeButton={false} className={styles.wrapper} closeOnOverlayClick={loading ? false : true}>
      <div>
        <div className={styles.header}>
          <div className={styles.normalText}>When you activate a Study Plan...</div>
          <div className={styles.title}>Your account will be locked</div>
        </div>
        <div className={styles.safetyNote}>
          <SafetyIcon width={51} height={51}/>
          <span>This is a <strong>safety feature</strong> to prevent your child from accessing additional Units. To unlock your account, enter your password.</span>
        </div>
        <div className={styles.content}>
          <span className={styles.contentRow}>Are you ready to give your child access to start their Study Plan?</span>
          {Boolean(beError) && <div className={styles.error}>{beError}</div>}
          <div className={styles.action}>
            <Button disabled={loading} size="small" className={styles.cancelButton} onClick={handleCancel} label={'Cancel'}/>
            <Button disabled={loading} size="small" leftIcon={loading ? <Spinner width={20} height={20} /> : undefined} className={styles.startButton} onClick={handleContinue} label={'Start Study Plan'}/>
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default LockModal;
